import DashboardLayout from '@/layouts/DashboardLayout.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import auth from '@/middleware/auth';
import type { Middleware } from '@/types/router';
import { BroadcastsRouteName } from '@/types/router/name/broadcasts';
import { BroadcastsRoutePath } from '@/types/router/path/broadcasts';

export default [
    {
        path: BroadcastsRoutePath.Broadcasts,
        name: BroadcastsRouteName.Broadcasts,
        component: () => import('@/pages/broadcasts/index.vue'),
        meta: {
            group: 'broadcasts',
            title: 'Broadcasts',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: BroadcastsRoutePath.Create,
        name: BroadcastsRouteName.Create,
        component: () => import('@/pages/broadcasts/create/index.vue'),
        meta: {
            group: 'broadcasts-create',
            title: 'Create Broadcasts',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    }
];
